import React from 'react';

import {
  Filter,
  Box,
  InputField,
  ListItem,
  DatepickerGroup,
  useWindowSize,
  Typography,
} from 'vindi-ds-components';

import { PrDownload } from 'vindi-ds-icons/pr';

const FilterQuickContainer = ({ onClickDownload, quick }) => {
  const actions = [
    { label: 'Exportar', icon: <PrDownload />, onClick: onClickDownload },
  ];

  return (
    <Filter.QuickContainer actions={actions}>
      <Box width={{ sm: '100%', md: '288px' }}>
        <InputField name={quick.period.name} placeholder={quick.period.placeholder} select>
          {quick.period.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Box>
    </Filter.QuickContainer>
  );
};

const FilterPeriod = ({
  title,
  nameInitialDate,
  labelInitialDate,
  placeholderInitialDate,
  nameFinalDate,
  labelFinalDate,
  placeholderFinalDate,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <Box width='100%'>
      <Box m={1 / 2}>
        {!isMobile && <Typography color='textPrimary'>{title}</Typography>}
      </Box>

      <Box
        display='grid'
        gridTemplateColumns={{ sm: '1fr', md: '1fr 1fr' }}
        gap={1}
      >
        <DatepickerGroup>
          <InputField
            name={nameInitialDate}
            label={labelInitialDate}
            placeholder={placeholderInitialDate}
            selectsStart
            datepicker
            hasRange
          />
          <InputField
            name={nameFinalDate}
            label={labelFinalDate}
            placeholder={placeholderFinalDate}
            selectsEnd
            datepicker
            hasRange
          />
        </DatepickerGroup>
      </Box>
    </Box>
  );
};

const FilterAdvancedFirstColumn = ({ className, advanced }) => {
  const { isMobile } = useWindowSize();

  const { start, end, payment } = isMobile ? advanced.dates.mobile : advanced.dates.desktop;

  return (
    <Filter.Column className={className}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        <FilterPeriod {...start} />
        <FilterPeriod {...end} />
        <FilterPeriod {...payment} />
      </Box>
    </Filter.Column>
  );
};

const FilterAdvancedSecondColumn = ({ className, advanced }) => (
  <Filter.Column className={className}>
    <Box mt={{ xs: 1, sm: 0 }}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        <InputField
          name={advanced.status.name}
          label={advanced.status.label}
          placeholder={advanced.status.placeholder}
          select
          multiOpts
        >
          {advanced.status.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>

        <InputField
          name={advanced.paymentMethod.name}
          label={advanced.paymentMethod.label}
          placeholder={advanced.paymentMethod.placeholder}
          select
          multiOpts
        >
          {advanced.paymentMethod.options.map(({ key, value }) => (
            <ListItem key={key} value={value}>{key}</ListItem>
          ))}
        </InputField>
      </Box>
    </Box>
  </Filter.Column>
);

const FilterAdvancedContainer = ({ advanced }) => (
  <Filter.AdvancedContainer>
    <FilterAdvancedFirstColumn
      advanced={advanced}
    />
    <FilterAdvancedSecondColumn
      advanced={advanced}
    />
  </Filter.AdvancedContainer>
);

const FiltersSubscriptions = ({ onClickDownload, filterFields }) => (
  <Box mt={3}>
    <FilterQuickContainer
      onClickDownload={onClickDownload}
      quick={filterFields.filters.quick}
    />

    <Box mb={3}>
      <FilterAdvancedContainer
        advanced={filterFields.filters.advanced}
      />
    </Box>

  </Box>
);

export default FiltersSubscriptions;
